export default __webpack_public_path__ + "static/media/C230251.0d1e5ad8.jpg";